import { MenuItem } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { useCaseLink } from '../../../../../../ClientRoutes';
import History from '../../../../../../History';
import { UseCaseItem } from '../../../../../Dropdown/Types';
import { NavigationMenuItemProps } from '../Types';
import UseCaseInfo from './UseCaseInfo';

function UseCaseMenuItem({ item }: NavigationMenuItemProps<UseCaseItem>) {
  const handleMenuItemClick = (item: UseCaseItem) => () => {
    History.push(useCaseLink(item));
  };

  return (
    <MenuItem
      data-testid={`learning-collections-menu_${item.id}-menu-item`}
      className="group"
      aria-label={item.name.text}
      onClick={handleMenuItemClick(item)}
      data-intercom-target="learning-collection-dropdown"
      data-collection-id={item.content.uuid}
      data-collection-name={item.name.text.replace(/\s+/g, '-').toLowerCase()}
    >
      <UseCaseInfo data={item.content} />
    </MenuItem>
  );
}

export default observer(UseCaseMenuItem);
